import { usePlaceLookupWithListingStats } from '@hcs/places';
import { DateStr } from '@hcs/types';

import { placeLookupListingStatsTSToCerberusListingStats } from '../utils/cerberus-stats.utils';

export const useCityListingStatsTimeSeries = ({
  placeId,
  fromDate,
  toDate,
}: {
  placeId: string | null | undefined;
  fromDate?: DateStr;
  toDate?: DateStr;
  enabled?: boolean;
}) => {
  const response = usePlaceLookupWithListingStats({
    placeId,
    fromDate,
    toDate,
  });
  return {
    ...response,
    data: response.data
      ? placeLookupListingStatsTSToCerberusListingStats(response.data)
      : null,
  };
};
